

































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { stripHtml } from "@/utils/SanitizeUtils";

@Component({
	components: {},
})
export default class PortalNotifications extends Vue {
	stripHtml(value: string): string {
		return stripHtml(value);
	}

	handleClose(customFunc: undefined | (() => void), closeFn: () => void) {
		if (customFunc) {
			customFunc();
		}
		closeFn();
	}
}
